import { Note, Study } from 'pages/StudyList/StudyList';
import {
  NOTES_ROUTE,
  NOTE_ROUTE,
  createURL,
  tokenizeRoute,
} from 'query/routes';

export const fetchNotes = async (
  reviewStudyId: Study['id']
): Promise<Note[]> => {
  const url = tokenizeRoute(NOTES_ROUTE, {
    review_study_id: reviewStudyId,
  });

  return fetch(url.toString(), {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());
};

export const createNote = async (
  note: string,
  category: string,
  reviewStudyId: Study['id']
) => {
  const url = createURL(NOTES_ROUTE);

  return fetch(url.toString(), {
    method: 'POST',
    body: JSON.stringify({ note, category, review_study_id: reviewStudyId }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      const response = res.json() as unknown;
      return response as Note;
    }

    return Promise.reject(res);
  });
};

export const updateNote = async (note: string, noteId: number) => {
  const url = tokenizeRoute(NOTE_ROUTE, {
    note_id: noteId.toString(),
  });

  return fetch(url.toString(), {
    method: 'PUT',
    body: JSON.stringify({ note }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  });
};

export const deleteNote = async (noteId: number) => {
  const url = tokenizeRoute(NOTE_ROUTE, {
    note_id: noteId.toString(),
  });

  return fetch(url.toString(), {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.ok) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  });
};
